import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { defaultColumns } from "@/features/permissions/constants/columns.constant";
import { KeyRound, SearchIcon } from "lucide-react";
import { PermissionData, PermissionTableItem } from "@/common/types/permissions";
import { useTmaisPermissions } from "@/common/hooks/queries/useTmaisPermissions";
import { TmaisPermissionsTransformer } from "../../services/tmaisPermissionsTransformer";

const TmaisPermissions = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: tmaisPermissions,
    meta,
    isPending: tmaisPermissionsIsPending,
    isLoading: tmaisPermissionsIsLoading,
    error: tmaisPermissionsError = {} as any,
    refetch: refetchTmaisPermissions,
  } = useTmaisPermissions({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<PermissionData[], PermissionTableItem[]>({
      transformer: TmaisPermissionsTransformer.tableTransformer()
    })
  });

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<KeyRound className="w-10 h-10" strokeWidth={1} />}
        title="Permissões - Tmais"
        createButtonText="Nova permissão"
        dataTestid="create_tmais_permission_button"
        operationKlassToCheckPermission="Admin::Tmais::Permissions::Create"
        disableCreateButton={tmaisPermissionsIsPending || tmaisPermissionsError?.status === 403}
      />

      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={tmaisPermissionsError?.status}
        refetchFunction={refetchTmaisPermissions}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              name="search"
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value);
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
              }}
              value={filterParams.search}
            />
          </div>

          <Table
            className="max-h-screen"
            columns={defaultColumns}
            isLoadingData={tmaisPermissionsIsLoading}
            page={filterParams.page || 1}
            rows={tmaisPermissions}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default TmaisPermissions;
